import Dialog from "./abstract/AbstractDialog";

export default class DialogSaveQuery extends Dialog {
  constructor(template, callback = null) {
    super(template, callback);
  }

  init(lastQueryUid, lastQueryName, lastDescName) {
    super.init();
    this.lastQueryUid = lastQueryUid;
    this.lastQueryName = lastQueryName;
    this.lastDescName = lastDescName;
    const field = this.dialog.querySelector(".js-input-text");
    field.value = lastQueryName;
    const textarea = this.dialog.querySelector(".js-input-desc");
    textarea.value = lastDescName;

    if (lastQueryUid) {
      jQuery(this.dialog.querySelector(".js-btn-confirm")).hide();
      jQuery(this.dialog.querySelector(".js-btn-update")).on("click", this.onConfirm.bind(this));
      jQuery(this.dialog.querySelector(".js-btn-newone")).on("click", this.newOne.bind(this));
    } else {
      jQuery(this.dialog.querySelector(".js-btn-update")).hide();
      jQuery(this.dialog.querySelector(".js-btn-newone")).hide();
    }
  }

  newOne(e) {
    this.lastQueryUid = null;
    this.onConfirm(e);
  }

  onConfirm(e) {
    e.preventDefault();
    const field = this.dialog.querySelector(".js-input-text");
    const value = field.value;
    const fieldt = this.dialog.querySelector(".js-input-desc");
    const valuet = fieldt.value;

    if (value.length < 3) {
      field.classList.add("has-error");
    } else {
      field.classList.remove("has-error");
      this.hide();
      this.callback?.call(null, { uid: this.lastQueryUid, name: value, desc: valuet });
    }
  }

  onDismiss(e) {
    e.preventDefault();
    this.hide();
    this.callback?.call(null, null);
  }
}
